import { z } from 'zod';

export const OperatorSchema = z.object({
  id: z.string(),
  name: z.string().min(1).max(100),
  serialNumber: z.string().min(1).max(50).optional(),
  // Preserved for backwards compatibility
  licenseNumber: z.string().min(1).max(50).optional(),
});

export type Operator = z.infer<typeof OperatorSchema>;
